/**
 * Slot-label character policy:
 * - lowercase a–z, digits 0–9, underscore (spaces become `_`)
 * - keep: ' " - [ ] ( ) { } . , / ! @ * #
 * - strip everything else (control chars, emoji, `$%^&=|\\<>?;:`~ etc.)
 */

const SLOT_LABEL_ALLOWED_RE = /[^a-z0-9_'"\-\[\](){}.,/!@*#]+/g;

/** As-you-type sanitize: lower, spaces→_, strip illegal, collapse repeated `_`. */
export function sanitizeSlotLabelInput(raw: string): string {
  return String(raw ?? "")
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(SLOT_LABEL_ALLOWED_RE, "")
    .replace(/_+/g, "_");
}

/** Canonical stored form: sanitize, then trim leading/trailing underscores. */
export function normalizeSlotLabel(raw: string): string {
  return sanitizeSlotLabelInput(raw).replace(/^_+|_+$/g, "");
}

export function normalizeSlotLabelsCsv(raw: string): string {
  const parts = raw
    .split(",")
    .map((s) => normalizeSlotLabel(s))
    .filter((s) => s.length > 0);
  return [...new Set(parts)].join(", ");
}

export function parseSlotLabelsCsv(raw: string): string[] {
  const parts = raw
    .split(",")
    .map((s) => normalizeSlotLabel(s))
    .filter((s) => s.length > 0);
  return [...new Set(parts)];
}

export function slotLabelsMatch(a: string, b: string): boolean {
  return normalizeSlotLabel(a) === normalizeSlotLabel(b);
}
